import React from 'react';
import PropTypes from 'prop-types';

import Styles from './FormTitle.styles';

const FormTitle = ({ children }) => (
  <h3 className={Styles.default}>{children}</h3>
);

FormTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormTitle;
